var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-footer"},[_vm._v("\n  由北京鲁班工匠提供技术支持\n")])}
var staticRenderFns = []

export { render, staticRenderFns }